import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation, Thumbs } from 'swiper';
import SwiperCore, { Pagination } from 'swiper/core';
import { parseDateTime, showCountOfImages, showVideoLength } from '../Partials/Helper';
import { requestGet } from '../../api/request';
import { BANNER } from '../../api/url';

const Banner = () => {
  const navigate = useNavigate();

  SwiperCore.use([Pagination]);

  const [banner, setBanner] = useState([]);
  const [direction, setDirection] = useState('rtl');

  const currentLanguage = useSelector(
    (state) => state.languageReducer.current_language,
  );
  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  // const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const thumbsSwiper = null;

  const getBannerInfo = async () => {
    const response = await requestGet(BANNER, {
      'lang_id': currentLanguage.id,
    });

    if (response.success) {
      setBanner(response.data);
    }
  };

  useEffect(() => {
    if (dictionary) {
      getBannerInfo();
    }
  }, [currentLanguage]);

  useEffect(() => {
    if (document.dir === 'rtl') {
      setDirection('rtl');
    } else {
      setDirection('ltr');
    }
  }, [direction]);

  const handleKeyPress = () => {};

  const redirect = (data) => {
    if (data.news_type_relation[0].news_type.name === 'government_assembly') {
      navigate(
        `/government/government_sessions/${data.id}`,
      );
    } else if (data.news_type_relation[0].news_type.type === 'news'
    && data.news_type_relation[0].news_type.name !== 'government_assembly') {
      navigate(
        `/event/${data.news_type_relation[0].news_type.name.replace('in_trips', 'domestic_trips').replace('out_trips', 'foreign_trips')}/${data.id}`,
      );
    } else if (!data.news_type_relation[0].news_type.type !== 'news') {
      navigate(
        `/event_by_theme/${data.news_type_relation[0].news_type.type}/${data.news_type_relation[0].news_type.name.replace('in_trips', 'domestic_trips').replace('out_trips', 'foreign_trips')}/${data.id}`,
      );
    }
  };

  const hrefReditect = (data) => {
    if (data.news_type_relation[0].news_type.name === 'government_assembly') {
      return (
        <a
          href={`/government/government_sessions/${data.id}`}
          className="main-swiper__title"
        >
          {data.title}
        </a>
      );
    } else if (data.news_type_relation[0].news_type.type === 'news'
    && data.news_type_relation[0].news_type.name !== 'government_assembly') {
      return (
        <a
          href={`/event/${data.news_type_relation[0].news_type.name
            .replace('in_trips', 'domestic_trips')
            .replace('out_trips', 'foreign_trips')}/${data.id}`}
          className="main-swiper__title"
        >
          {data.title}
        </a>
      );
    } else if (!data.news_type_relation[0].news_type.type !== 'news') {
      return (
        <a
          href={`/event_by_theme/${data.news_type_relation[0].news_type.type}/${data.news_type_relation[0].news_type.name
            .replace('in_trips', 'domestic_trips')
            .replace('out_trips', 'foreign_trips')}/${data.id}`}
          className="main-swiper__title"
        >
          {data.title}
        </a>
      );
    }
  };

  const showSwiperImage = (data) => {
    const item = data.news_flickr_image_relation
      .filter((item) => item.id === data.news_banner_relation[0].flickr_image_id);
    return item.map((value) => <img key={value.id} loading="lazy" src={value.src} alt="" />);
  };

  return (
    <section className="container container-fliud">
      <div className="main-slide">
        <div className="swiper main-swiper">
          {banner && banner.length > 0 ? (
            <>
              <div className="swiper-wrapper">
                <Swiper
                  spaceBetween={100}
                  speed={800}
                  dir={direction}
                  navigation={{
                    navigation: true,
                    nextEl: '.main-swiper-next',
                    prevEl: '.main-swiper-prev',
                  }}
                  pagination={{
                    clickable: true,
                    el: '.main-swiper-pagination',
                  }}
                  loop={true}
                  thumbs={{ swiper: thumbsSwiper }}
                  preloadImages={false}
                  modules={[FreeMode, Navigation, Thumbs]}
                >
                  {banner.length > 0
                    ? banner.map((data) => (
                      <SwiperSlide key={data.id}>
                        <div className="swiper-slide">
                          <div className="main-swiper__slide">
                            <div className="main-swiper__img">
                              {showSwiperImage(data)}
                            </div>
                            <div className="main-swiper__content">
                              <div
                                className="main-swiper__title"
                                onClick={(e) => {
                                  e.preventDefault();
                                  redirect(data);
                                }}
                                onKeyDown={handleKeyPress}
                                role="button"
                                tabIndex="0"
                                aria-label="swiper"
                              >
                                {hrefReditect(data)}

                              </div>
                              <div className="main-swiper__info">
                                <div className="main-swiper__item">
                                  {
                                  data.news_flickr_image_relation
                                  && data.news_flickr_image_relation.filter((t) => t.type === 'original').length > 0 ? (
                                    <div className="main-swiper__box">
                                      <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M7.18652 11.0417C7.98043 11.0417 8.62402 10.3982 8.62402 9.60425C8.62402 8.81034 7.98043 8.16675 7.18652 8.16675C6.39261 8.16675 5.74902 8.81034 5.74902 9.60425C5.74902 10.3982 6.39261 11.0417 7.18652 11.0417Z" />
                                        <path d="M10.0615 13.9166L8.62402 11.9999L5.74902 15.8333H17.249L12.9365 10.0833L10.0615 13.9166Z" />
                                        <path d="M19.1658 4.33325H3.83244C2.7754 4.33325 1.91577 5.19288 1.91577 6.24992V17.7499C1.91577 18.807 2.7754 19.6666 3.83244 19.6666H19.1658C20.2228 19.6666 21.0824 18.807 21.0824 17.7499V6.24992C21.0824 5.19288 20.2228 4.33325 19.1658 4.33325ZM3.83244 17.7499V6.24992H19.1658L19.1677 17.7499H3.83244Z" />
                                      </svg>
                                      {showCountOfImages(data)}
                                    </div>
                                    ) : null
                                  }
                                  {
                                    data.assets
                                    && data.assets
                                      .filter((t) => t.asset_type_id === 2).length > 0 ? (
                                        <div className="main-swiper__box">
                                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                              d="M11.5001 2.41675C6.21583 2.41675 1.91675 6.71583 1.91675 12.0001C1.91675 17.2843 6.21583 21.5834 11.5001 21.5834C16.7843 21.5834 21.0834 17.2843 21.0834 12.0001C21.0834 6.71583 16.7843 2.41675 11.5001 2.41675ZM11.5001 19.6667C7.27287 19.6667 3.83341 16.2273 3.83341 12.0001C3.83341 7.77287 7.27287 4.33341 11.5001 4.33341C15.7273 4.33341 19.1667 7.77287 19.1667 12.0001C19.1667 16.2273 15.7273 19.6667 11.5001 19.6667Z"
                                            />
                                            <path d="M8.625 16.7916L16.2917 11.9999L8.625 7.20825V16.7916Z" />
                                          </svg>
                                          {showVideoLength(data)}
                                        </div>
                                      ) : null
                                  }
                                </div>
                                <div className="main-swiper__item">
                                  <span>
                                    {parseDateTime(data.publish_date)}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))
                    : null}
                </Swiper>
              </div>
              <div className="main-swiper-prev">
                <svg
                  width="12"
                  height="20"
                  viewBox="0 0 12 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.7585 1.03456L1.79297 10.0001L10.7585 18.9656"
                    stroke="black"
                    strokeWidth="2.06897"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="main-swiper-next">
                <svg
                  width="12"
                  height="20"
                  viewBox="0 0 12 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.24128 1.03456L10.2068 10.0001L1.24128 18.9656"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="main-swiper-pagination__box">
                <div className="main-swiper-pagination" />
              </div>
            </>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default Banner;
